<SearchableList
    searchLabel={lang.main('Search_for_participants')}
    searchPlaceholder={lang.main('Search_for_participants')}
    bind:selectedIds
    {pageSizesList}
    {getItemsFn}
    getNameFn={(item) => item.fullName}
    searchEmptyTitle={lang.main("No_results")}
    searchEmptyDescription={lang.main("Course_participants_No_participants_found_search_result")}
    emptyTitle={lang.main("No_persons")}
    emptyDescription={lang.main("This_course_has_no_participants")}
    emptyStateIcon="user"
    emptyStateLinkText={lang.main("Add_persons")}
    {emptyStateLinkUrl}
    on:error
>
    <ParticipantHeader slot="headerTemplate" />
    <ParticipantRow slot="rowTemplate" let:item item={item} />
</SearchableList>

<script lang="ts">
    import { onMount } from "svelte";
    import { lang } from "@its-ui/mono/lang/provider";

    import SearchableList from "../SearchableList.svelte";
    import ParticipantHeader from './ParticipantHeader.svelte';
    import ParticipantRow from './ParticipantRow.svelte';
    import type { GetParticipantsFn } from "../../courseParticipantsDataProvider";

    export let selectedParticipantIds: number[];
    export let getParticipantsFn: GetParticipantsFn;
    export let emptyStateLinkUrl: string;
    export let pageSizesList: number[];

    let selectedIds: number[] = [];

    async function getItemsFn(pageIndex: number, pageSize: number, searchText?: string) {
        const response = await getParticipantsFn(pageIndex, pageSize, searchText);
        return {
            totalCount: response.totalCount,
            items: response.participants.map(p => ({
                id: p.personId,
                value: p
            }))
        };
    }

    onMount(() => {
        selectedIds = selectedParticipantIds ? [ ...selectedParticipantIds ] : [];
    });

    export function getSelectedValues(): number[] {
        return selectedIds;
    }
</script>